import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

declare var gtag: (...args: any[]) => void;

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
    deviceInfo = null;
    isMobile: Boolean = false;
    test : Date = new Date();
    focus;
    focus1;
    focus2;
    customerName;
    customerEmail;
    message;
    phoneNumber;

    constructor( private deviceService: DeviceDetectorService) {
        this.checkDeviceType();
     }

    ngOnInit() {
        this.customerName = '';
        this.customerEmail = '';
        this.phoneNumber = '+5541996635645'; 
    }

    checkDeviceType() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        this.isMobile = this.deviceService.isMobile();
    }
    
    setMessage() {
        let text;
        if (this.customerName !== '') {
            let emailPart = this.customerEmail !== '' ? ` Meu e-mail para contato é ${this.customerEmail}.` : '';
            text = `Olá! Meu nome é ${this.customerName}, tive um problema em minha viagem e preciso da ajuda de vocês.${emailPart} ✈️🚌`;
        } else {
            text = `Olá! Tive um problema em minha viagem e preciso da ajuda de vocês ✈️🚌`;
        }
        this.message = encodeURIComponent(text);
    }

    // Mesmo padrão do whatsappClick() do navbar: dispara em paralelo,
    // sem preventDefault()/event_callback — o link continua abrindo
    // normalmente (target="_blank").
    whatsappClick() {
        gtag('event', 'conversion', {
            'send_to': 'AW-10808804687/LhHpCLHZ9e8cEM-KhaIo',
            'value': 1.0,
            'currency': 'BRL'
        });
    }

    emailClick() {
        gtag('event', 'conversion', {
            'send_to': 'AW-10808804687/yseaCOfTgfAcEM-KhaIo',
            'value': 1.0,
            'currency': 'BRL'
        });
    }
}
